// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"44916582","484":"55d9be10","851":"19c2f1ea","950":"3a8f1193"}[chunkId] + ".chunk.js";
};